import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const redirect = params.get('redirect') || '/dashboard';

    if (token) {
      localStorage.setItem('token', token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      if (redirect.startsWith('http')) {
        window.location.href = redirect;
      } else {
        navigate(redirect);
      }
    } else {
      navigate('/login');
    }
  }, [navigate]);

  return (
    <div style={{minHeight:'100vh', background:'#f4f1eb', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'system-ui, sans-serif'}}>
      <p style={{color:'#6b6b6b'}}>Signing you in...</p>
    </div>
  );
}
